export default {
  data() {
    return {
      searchTitle: '',
      disabelConfirm: false,
      doctorTableInformationHeader: [
        {
          text: '#',
          value: 'icon',
          align: 'center',
          width: 60,
          sortable: false,
          isActive: true
        },
        {
          text: 'کد آمبولانس',
          value: 'ambulanceCode',
          align: 'center',
          width: 120,
          sortable: false,
          isActive: true
        },
        {
          text: 'شکایت اصلی',
          value: 'cc',
          align: 'center',
          width: 150,
          sortable: false,
          isActive: true
        },
        {
          text: 'توضیح شکایت',
          value: 'chiefComplaintNote',
          align: 'center',
          width: 200,
          sortable: false,
          isActive: true
        },
        {
          text: 'وضعیت آمبولانس',
          value: 'ambulanceStatus',
          align: 'center',
          width: 200,
          sortable: false,
          isActive: true
        },
        {
          text: 'وضعیت ماموریت',
          value: 'missionStatus',
          align: 'center',
          width: 200,
          sortable: false,
          isActive: true
        },
        {
          text: 'بیمارستان',
          value: 'hospital',
          align: 'center',
          width: 120,
          sortable: false,
          isActive: true
        },
        {
          text: 'شماره تماس',
          value: 'phoneNumber',
          align: 'center',
          width: 170,
          sortable: false,
          isActive: true
        },
        {
          text: 'شهر',
          value: 'city',
          align: 'center',
          width: 150,
          sortable: false,
          isActive: true
        },
        {
          text: 'آدرس',
          value: 'address',
          align: 'center',
          width: 500,
          sortable: false,
          isActive: true
        },
        {
          text: 'کابر 115',
          value: 'user115',
          align: 'center',
          width: 200,
          sortable: false,
          isActive: true
        },
      ],
      doctorMissions: [],
      missionPhoneId: null,
      missionId: null,
      phoneId: null,
      orderModal: false,
      closeOnContentClick: false,
      rightClickItems: [
        { title: 'تماس با کد', icon: 'mdi-phone-log mdi-flip-h mdi-18px' },
        { title: 'تماس داخلی', icon: 'mdi-phone-log mdi-flip-h mdi-18px' },
        { title: 'تماس خارجی', icon: 'mdi-phone-forward mdi-flip-h mdi-18px' },
        { title: 'تماس با مددجو', icon: 'mdi-card-account-phone mdi-18px' },
      ],
      iternalPhoneNumber: '',
      externalPhoneNumber: '',
      codePhoneNumbers: [],
      patientPhoneNumbers: [],
      showMenu: false,
      x: 0,
      y: 0,
    };
  },
  methods: {
    showDoctorInformationModal: function (value, data) {
      this.missionPhoneId = data.item.id;
      this.missionId = data.item.missionId;
      this.phoneId = data.item.phoneId;
      this.orderModal = true;
    },
    rightClickHandler(e, data) {
      e.preventDefault();
      this.codePhoneNumbers = data.item.codePhoneNumbers;
      this.patientPhoneNumbers = data.item.patiantPhoneNumbers;
      this.missionPhoneId = data.item.id;
      this.missionId = data.item.missionId;
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    rightClickAction: function (type, to) {
      this.showMenu = false;
      if (type == 'تماس با کد') {
        if (to) {
          let data = {
            missionPhoneId: this.missionPhoneId,
            missionId: this.missionId,
            to: to,
          };
          this.callToCodeFunction(data);
          this.showMenu = false;
        } else {
          this.snackText = 'کد شماره ثبت شده ای ندارد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      } else if (type === 'تماس با بیمارستان') {
        if (to) {
          let data = {
            missionPhoneId: this.missionPhoneId,
            missionId: this.missionId,
            to: to,
          };
          this.callToHospitalFunction(data);
          this.showMenu = false;
        } else {
          this.snackText = 'شماره تماس را وارد نمایید';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      } else if (type == 'تماس با مددجو') {
        if (to) {
          let data = {
            missionPhoneId: this.missionPhoneId,
            missionId: this.missionId,
            to: to,
          };
          this.callToPatientFunction(data);
          this.showMenu = false;
        }
      } else if (type == 'تماس داخلی') {
        if (this.iternalPhoneNumber) {
          let data = {
            missionPhoneId: this.missionPhoneId,
            missionId: this.missionId,
            to: this.iternalPhoneNumber,
          };
          this.callToInternalFunction(data);
          this.iternalPhoneNumber = '';
          this.showMenu = false;
        } else {
          this.snackText = 'شماره تماس را وارد نمایید';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      } else if (type === 'تماس خارجی') {
        if (this.externalPhoneNumber) {
          let data = {
            missionPhoneId: this.missionPhoneId,
            missionId: this.missionId,
            to: this.externalPhoneNumber,
          };
          this.callToCustomNumber(data);
          this.externalPhoneNumber = '';
          this.showMenu = false;
        } else {
          this.snackText = 'شماره تماس را وارد نمایید';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      }
    },
  },
};
